module.exports = "<svg viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.5 21C4.71 21 0 16.29 0 10.5S4.71 0 10.5 0 21 4.71 21 10.5 16.29 21 10.5 21zm0-19.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75-3.925-8.75-8.75-8.75zm-.217 12.826a.871.871 0 0 1-1.204.107l-4.376-3.5a.876.876 0 0 1 1.093-1.366l3.721 2.976 5.575-6.369a.875.875 0 1 1 1.316 1.152l-6.125 7z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/check-circle.svg
// module id = F13r
// module chunks = 89